export default "__VITE_ASSET__Cr7_MCHb__"